import * as React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider, createTheme } from '@mui/material/styles';

import { inputsCustomizations } from './customizations/inputs';
import { dataDisplayCustomizations } from './customizations/dataDisplay';
import { feedbackCustomizations } from './customizations/feedback';
import { navigationCustomizations } from './customizations/navigation';
import { surfacesCustomizations } from './customizations/surfaces';
import { colorSchemes, typography, shadows, shape } from './themePrimitives';
import { getBrandThemeOverrides } from '../theme';

function AppTheme(props) {
  const { children, disableCustomTheme, themeComponents } = props;
  const brandOverrides = getBrandThemeOverrides();
  const theme = React.useMemo(() => {
    return disableCustomTheme
      ? {}
      : createTheme({
          cssVariables: {
            colorSchemeSelector: 'data-mui-color-scheme',
            cssVarPrefix: 'template',
          },
          colorSchemes: {
            light: {
              palette: {
                ...colorSchemes.light.palette,
                ...brandOverrides.palette,
              },
            },
            dark: colorSchemes.dark,
          },
          typography,
          shadows,
          shape,
          components: {
            ...themeComponents, // 👈 ensure this comes first to override defaults
            ...brandOverrides.components, // 👈 brand baseline overrides
            ...inputsCustomizations,
            ...dataDisplayCustomizations,
            ...feedbackCustomizations,
            ...navigationCustomizations,
            ...surfacesCustomizations,
          },
        });
  }, [disableCustomTheme, themeComponents, brandOverrides]);

  if (disableCustomTheme) {
    return <>{children}</>;
  }

  return (
    <ThemeProvider theme={theme} disableTransitionOnChange>
      {children}
    </ThemeProvider>
  );
}

AppTheme.propTypes = {
  children: PropTypes.node,
  disableCustomTheme: PropTypes.bool,
  themeComponents: PropTypes.object,
};

export default AppTheme;
